import React from 'react'
import PropTypes from 'prop-types'

import {
  container
} from './styles/Card.style.js'

const Card = ({ children }) => (
  <div className={container}>
    {children}
  </div>
)

Card.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.func,
    PropTypes.array
  ]).isRequired
}

export default Card
